import { useNavigate } from "react-router-dom"
import DynamicButton from "../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import LightGrayBgWrapper from "../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import BlueBadge from "../../../components/common/AdminCommonComponents/BlueBadge/BlueBadge"

const DeliveryZone = () => {

  const navigate = useNavigate()

  const tableData = [
    { ID: "S0001", country: "Pakistan", city: "Karachi", availableMethods: "Standard, Express, Economy", defaultRate: "$1.00" },
    { ID: "S0001", country: "Pakistan", city: "Karachi", availableMethods: "Standard, Express, Economy", defaultRate: "$1.00" },
    { ID: "S0001", country: "Pakistan", city: "Karachi", availableMethods: "Standard, Express, Economy", defaultRate: "$1.00" },
    { ID: "S0001", country: "Pakistan", city: "Karachi", availableMethods: "Standard, Express, Economy", defaultRate: "$1.00" },
  ]

  const columns = [
    {
      name: "ID",
      selector: (row) => row.ID,
      grow: 0.3,
    },
    {
      name: "Country",
      selector: (row) => row.country,
    },
    {
      name: "City",
      selector: (row) => row.city,
    },
    {
      name: "Available Methods",
      selector: (row) => row.availableMethods,
    },
    {
      name: "Default Rate",
      selector: (row) => row.defaultRate,
      cell: (row) => <BlueBadge theme="light-green" textBlack>{row.defaultRate}</BlueBadge>,
      center: 'true'
    },
    {
      name: "Actions",
      cell: () => (
        <div className="d-flex gap-2 align-items-center">
          <button style={{ all: "unset" }}>Edit</button>
          <button style={{ all: "unset" }}>Delete</button>
        </div>
      ),
    },
  ]

  return (
    <LightGrayBgWrapper>

      <div className="fw-semibold fs-5 mb-3">Delivery Zone</div>

      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow">
        <div className="fw-semibold fs-5">Delivery types</div>
        <DynamicButton theme="blue" onClick={() => navigate('/shipping-and-delivery/delivery-zones/add-new-delivery-zone')}>
          Add new
        </DynamicButton>
      </div>

      <DynamicDatatable columns={columns} data={tableData} type="yellow" />
    </LightGrayBgWrapper>
  )
}

export default DeliveryZone
